import React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BocciaTimer from './components/BocciaTimer';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BocciaTimer />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;